// extracted by mini-css-extract-plugin
export default {"contentBlockRoot":"ContentBlock_contentBlockRoot__faCou","small":"ContentBlock_small__XCg7R"};